let navigate: ((path: string) => void) | undefined;

export const setNavigate = (nav: (path: string) => void) => {
    navigate = nav;
};

export const getNavigate = () => {
    return navigate;
};